// /User/ui_design/src/Components/Counter.js
import React, { useEffect, useState, useCallback } from "react";
import "./Counter.css";

export default function Counter({ counter = {} }) {
  // animated values
  const [food, setFood] = useState(0);
  const [patients, setPatients] = useState(0);
  const [rides, setRides] = useState(0);
  const [volunteer, setVolunteer] = useState(0);

  // small helper to run a number from 0 -> target
  const animate = useCallback((setter, to, duration = 1800) => {
    if (to == null) to = 0;
    const start = 0;
    const t0 = performance.now();
    const step = (now) => {
      const p = Math.min((now - t0) / duration, 1);
      setter(Math.floor(start + (to - start) * p));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, []);

  useEffect(() => {
    animate(setFood, Number(counter.food) || 0);
    animate(setPatients, Number(counter.patients) || 0);
    animate(setRides, Number(counter.ride) || 0);
    animate(setVolunteer, Number(counter.volunteer) || 0);
  }, [counter.food, counter.patients, counter.ride, counter.volunteer, animate]);

  /* ====== layout styles (kept compact) ====== */
  const styles = {
    outer: {
      width: "100%",
      padding: "18px 0 6px",
    },
    row: {
      maxWidth: 1200,
      margin: "0 auto",
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      gap: 28,
      flexWrap: "wrap",
    },
    card: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      minWidth: 180,
    },
    circle: {
      width: 170,
      height: 170,
      borderRadius: "50%",
      background: "#fff",
      border: "10px solid #6B4DFF", // your purple ring
      boxShadow: "0 10px 24px rgba(0,0,0,0.06)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    number: {
      fontSize: 54,
      fontWeight: 900,
      color: "var(--text-heading)",
      lineHeight: 1,
    },

    /* 👉 Bigger labels (inline so they override any old CSS) */
    labelBlock: {
      marginTop: 12,
      textAlign: "center",
      lineHeight: 1.15,
      color: "var(--text-heading)",
      fontWeight: 800,
      fontSize: "clamp(18px, 2.2vw, 26px)",  // <— this is the size you asked for
    },
    labelLine: { display: "block", marginTop: 3 },
  };

  const Item = ({ value, line1, line2 }) => (
    <div style={styles.card} className="achievement">
      <div style={styles.circle} className="circle">
        <span style={styles.number}>{value}</span>
      </div>
      <div style={styles.labelBlock} className="counter-label">
        <span style={{ display: "block" }}>{line1}</span>
        <span style={styles.labelLine}>{line2}</span>
      </div>
    </div>
  );

  return (
    <section style={styles.outer} aria-label="Impact counters">
      <div style={styles.row}>
        <Item value={food} line1="Meals" line2="Delivered" />
        <Item value={patients} line1="Patients" line2="Assisted" />
        <Item value={rides} line1="Rides" line2="Provided" />
        <Item value={`${volunteer}+`} line1="Home Services'" line2="Hours" />
      </div>
    </section>
  );
}
